import { useCallback, useEffect, useRef, useState } from "react";
import { _RemoteAbstractAction, _single } from "../../../core/services/dataBean/EntityCatalog";
import useDataBean from "../../../core/services/dataBean/useDataBean";
import { PrintJson } from "../../theme/Component/PrintJson";
import { BasicButton } from "../../theme/Component/BasicButton";
import { toast } from "react-toastify";
import useModal, { MODAL_LG, MODAL_md } from "../../theme/Component/hooks/useModal";
import { Modal } from "../../theme/Component/Modal";
import { env } from "../../../env";
import { AbstractStep } from "./AbstractStep";
import { useObjectRenderer } from "./hooks/useObjectRenderer";

interface Props {
    idApplicationInvoker: any;
    fieldList: any;
    data: any;
    setData: any;
    useAsForm: boolean;
    propertyName?: string;
    remote?: any;
}
export const RemoteForm = ({ idApplicationInvoker, fieldList, data, propertyName, setData, useAsForm, remote }: Props) => {

    const { instance } = useDataBean(_RemoteAbstractAction);
    const [bean, setBean] = useState<any>({});
    const [required, setRequired] = useState<any>([]);
    const [events, setEvents] = useState<any>([]);
    const [errList, setErrList] = useState<any>([]);
    const [formValid, setFormValid] = useState<boolean>(true);
    const [campos, setCampos] = useState<any>([]);
    const containerRef = useRef<HTMLDivElement>(null);
    const modalStructure = useModal("Estructura", MODAL_LG);
    const modalDatos = useModal("Datos", MODAL_md);
    const _printLog = env.PRINT_LOG;
    const modalERR = useModal("Inconsistencias", MODAL_md);
    const lastBean = useRef<any>({});
    const lastEvent = useRef<string>('');


    useEffect(() => {

        if (fieldList) {
            const rows = Object.keys(fieldList);
            let filas = [];
            rows.forEach(fila => {
                filas.push(
                    {
                        ...fieldList[fila], "IDProperty": fila, "LineNumber": fieldList[fila].LineNumber ?? 1
                    }
                )
            });

            // obtener las propiedades obligatorias
            if (useAsForm) {
                setRequired(
                    filas.filter((item) => item.Required && item.VisibleOnTableForm).map((item) => item.IDProperty)
                );

            } else {

                setRequired(
                    filas.filter((item) => item.Required).map((item) => item.IDProperty)
                );
            }
            let eve = {};
            filas.forEach(element => {
                if (element.EventName) {
                    eve[element.IDProperty] = element.EventName;
                }
            });

            setEvents(eve);


            //ordenar y asignar 
            const camp = filas.sort((a, b) => a.LineNumber - b.LineNumber);
            const b = camp.filter((item) => item.DefaultValue)
                .reduce((acc, item) => {
                    acc[item.IDProperty] = item.DefaultValue;
                    return acc;
                }, {})


            let props = {};
            camp.forEach((element: any) => {
                if (element.EditorProperties) {

                    if (element.EditorProperties) {
                        props = Object.assign({}, props, element.EditorProperties);

                    }

                }

            });

            setBean({ ...b, ...props, ...data });
            setCampos(camp);
        }
        return () => { setBean({}) }

    }, [])

    useEffect(() => {
        let arr = propModify(lastBean.current, bean);

        if (arr.length > 0) {
            if (arr[0] in events) {
                console.log(arr[0]);
                console.log(events);
                console.log(events[arr[0]]);

                fireEvent(events[arr[0]], { ...bean });
            }
        }

        lastBean.current = { ...bean };
    }, [bean])

    const propModify = (original: Record<string, any>, modificado: Record<string, any>) => {
        const propiedadesCambiadas: string[] = [];

        for (const key in modificado) {
            if (modificado[key] !== original[key]) {
                propiedadesCambiadas.push(key);
            }
        }

        return propiedadesCambiadas;
    }



    const fireEvent = (evento: string, data: any) => {

        if (evento != lastBean.current) {
            lastEvent.current = evento;
            _single.printOut("FIRE EVENT => " + evento);
            instance.fireAbstractStepEvent(idApplicationInvoker, evento, data).then(
                (resp: any) => {
                    if (resp) {
                        setBean({ ...data, ...resp });
                        lastEvent.current = '';
                    }
                }
            ).catch(err => toast.error(err));

        }
    }


    const submitForm = () => {

        if (useAsForm) {
            instance.validateAbstractStepTableRow(idApplicationInvoker, propertyName, bean, 0, _single.getAccountID()).then(
                (resp: any) => {
                    _single.printOut("validateAbstractStepTableRow =>");
                    _single.printOut(resp);

                    if (resp.Validated === true) {

                        let b = { ...bean, ...resp.Properties };

                        setData(b);
                    }
                    else if (resp.MsgList) {
                        setErrList(resp.MsgList);
                        modalERR.open();
                    }
                }
            ).catch(err => toast.error(err))
        } else {
            instance.validateAbstractStepProperties(idApplicationInvoker, bean, _single.getAccountID()).then(
                (resp: any) => {
                    _single.printOut("validateAbstractStepProperties =>");
                    _single.printOut(resp);
                    if (resp.Validated === true) {
                        setData(bean);
                    } else if (resp.MsgList) {
                        setErrList(resp.MsgList);
                        modalERR.open();
                    }
                }
            ).catch(err => toast.error(err))
        }

    }



    const handleChange = (e) => {
        const newBean = { ...bean }; // Crear una copia nueva del objeto

        newBean[e.target.name] = _single.getValueInput(e);

        setBean(newBean); // Actualizar el estado con la nueva copia
        // if (events[e.target.name]) {
        //     fireEvent(events[e.target.name], newBean);
        // } else {
        // }
    };

    const updateAndFireEvent = (e: any, property: string) => {
        const newBean = { ...bean, [property]: e[property] }; // Crear una copia nueva del objeto
        setBean(newBean); // Actualizar el estado con la nueva copia
        // if (events[property]) {
        //     fireEvent(events[property], newBean);
        // } else {
        // }
    }

    const { renderInput } = useObjectRenderer({
        bean,
        setBean,
        idApplicationInvoker,
        data,
        handleChange,
        updateAndFireEvent,
        remote
    });



    return (
        <div className="container">

            <div className="row">
                {_printLog &&
                    <div className="col-md-12">
                        <button type="button" title="Estructura" className="btn btn-outline-primary btn-icon waves-effect waves-light shadow-none" onClick={() => { modalStructure.open() }}><i className="ri-layout-5-fill"></i></button>
                        <button type="button" title="Datos" className="btn btn-outline-primary btn-icon waves-effect waves-light shadow-none" onClick={() => { modalDatos.open() }}><i className="ri-code-fill"></i></button>
                    </div>
                }
                <div className="col-md-12">


                    <div className="row" ref={containerRef}>
                        {campos.map((campo: any, index: number) => {
                            return (
                                <div key={index} className={`col-md-${campo.GridSize ?? 6}`} lang={campo.ReturnClassForName} id={campo.IDProperty}>
                                    {renderInput(campo)}
                                </div>
                            )
                        })}
                    </div>
                    <div className="row">
                        <div className="col-md-6 mt-4">
                            {campos.length > 0 &&
                                <BasicButton disable={!formValid} icon="ri-send-plane-2-line" clase="primary" eventClick={submitForm}>{!useAsForm ? 'Siguiente' : 'Guardar'}</BasicButton>
                            }
                        </div>
                    </div>
                    <div className="row">
                        <div className="col">
                            <Modal modal={modalERR.modal} updateModal={modalERR.setModal}>
                                <div className="row">
                                    <div className="col">

                                        <ul className="list-group">
                                            {errList.map((item: any) => {
                                                return (
                                                    <li className="list-group-item">{item}</li>
                                                )
                                            })}
                                        </ul>

                                    </div>
                                </div>
                            </Modal>
                        </div>
                    </div>


                </div>
                <div className="col-md-12">
                    <Modal modal={modalStructure.modal} updateModal={modalStructure.setModal}>
                        {/* <PrintJson json={campos} /> */}
                        <AbstractStep fieldList={fieldList} />
                        <hr />

                    </Modal>
                    <Modal modal={modalDatos.modal} updateModal={modalDatos.setModal}>
                        <PrintJson json={bean} />
                    </Modal>

                </div>
            </div>
        </div>
    )
}